import React from 'react';
import PropTypes from 'prop-types';
import icons from '../Icons';
import './Icon.scss';
import { createClassList } from '../../utils/dom/class';

/**
 *
 * For further guidance on the Icon component, please visit the
   <a target="_blank" href="http://hqcontent.edwardjones.com/GUI/guisite/axiom-ds/guidelines/icons" class="axiom-link"> AXIOM</a>
    documentation site.
 <br/>
 <br/>
 * DEPRECATION NOTICE: This implementation of icons is being refactored for the next major version.
 *
 * To be consistent across all supported browsers (IE11, Edge, Chrome), no icons are focusable.
 *
 * Icons should not be resized without explicit direction from your designer as an exception,
 * as sizes other than those controlled by the Icon component are not approved in the design system.
 *
 * The 'size' prop was removed with Release/5.0.0 and instead replaced with icons appended with -sm
 */
const Icon = ({ name, seenByAssistiveTechnology, classes }) => {
  const classNames = ['axiom-icon','icon', `axiom-icon--${name}`, `icon--${name}`];

  return (
    <span
      data-testid='uxd-icon'
      role='presentation'
      className={createClassList({
        default: classNames,
        custom: classes,
        required: [],
      })}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(!seenByAssistiveTechnology
        ? { 'aria-hidden': 'true' }
        : {})}
    >
      {icons[name] || <>Icon Not Found</>}
    </span>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  seenByAssistiveTechnology: PropTypes.bool,
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

Icon.defaultProps = {
  seenByAssistiveTechnology: false,
  classes: [],
};

export default Icon;
